import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';

import {
  changeProjetoValue,
  saveProjeto,
  loadHistoricoAvaliacoes,
} from '../../../../../store/modules/ProjetoActions';

import { GenericProjectCard } from '../../../../../components/GenericProjectCard';
import { CustomCard } from '../../../../../components/CustomCard';
import { Row } from '../../../../../components/Row';
import { Col } from '../../../../../components/Col';
import { CustomTextArea } from '../../../../../components/CustomTextArea';
import { etapaIsUnlocked } from '../../../../../utils/ProjetoUtils';
import { openModal } from '../../../../../store/modules/ModalActions';

class Etapa5Card1 extends GenericProjectCard {
  stepIndex = 6;

  validationResults = [false];

  constructor(props) {
    super(props);

    this.state = {
      ...(this.state || {}),
      descricaoComponenteCurricularChanged: false,
      descricaoAtividadeDesenvolvidaChanged: false,
    };

    this.setValue = this.setValue.bind(this);
  }

  UNSAFE_componentWillMount() {
    this.props.loadHistoricoAvaliacoes(this.props.projeto.id, 5);
  }

  descricaoComponenteCurricularIsValid() {
    return this.props.projeto.descricaoComponenteCurricular
      ? this.props.projeto.descricaoComponenteCurricular.length > 0
      : false;
  }

  descricaoAtividadeDesenvolvidaIsValid() {
    return this.props.projeto.descricaoAtividadeDesenvolvida
      ? this.props.projeto.descricaoAtividadeDesenvolvida.length > 0
      : false;
  }

  render() {
    this.validationResults = !etapaIsUnlocked(
      this.stepIndex,
      this.props.projeto.avaliacoes
    )
      ? [true]
      : [
          this.descricaoComponenteCurricularIsValid(),
          this.descricaoAtividadeDesenvolvidaIsValid(),
        ];
    return (
      <CustomCard
        stepIndex={this.stepIndex}
        titleHint={this.props.languageValues.hintEtapa5}
        CardHeaderPropTypes={{
          title: this.props.languageValues.etapa5,
        }}
      >
        <form
          className={this.getFormClasses()}
          onSubmit={(event) => {
            event.preventDefault();
            if (this.itemsAreValid(this.validationResults)) {
              this.toNext();
            }
          }}
        >
          <Row className='form-row'>
            <Col cols={[12, 12, 12, 12, 12]}>
              <CustomTextArea
                label={this.props.languageValues.descricaoComponenteCurricular}
                name='descricaoComponenteCurricular'
                value={this.props.projeto.descricaoComponenteCurricular || ''}
                onChange={(event) => {
                  this.setValue(event);
                }}
                error={!this.descricaoComponenteCurricularIsValid()}
                counter={true}
                maxSize={2000}
                disabled={
                  this.props.lockedAllFields ||
                  !etapaIsUnlocked(
                    this.stepIndex,
                    this.props.projeto.avaliacoes
                  )
                }
              />
            </Col>
          </Row>
          <Row className='form-row'>
            <Col cols={[12, 12, 12, 12, 12]}>
              <CustomTextArea
                label={this.props.languageValues.descricaoAtividadeDesenvolvida}
                name='descricaoAtividadeDesenvolvida'
                value={this.props.projeto.descricaoAtividadeDesenvolvida || ''}
                onChange={(event) => {
                  this.setValue(event);
                }}
                error={!this.descricaoAtividadeDesenvolvidaIsValid()}
                counter={true}
                maxSize={2000}
                disabled={
                  this.props.lockedAllFields ||
                  !etapaIsUnlocked(
                    this.stepIndex,
                    this.props.projeto.avaliacoes
                  )
                }
              />
            </Col>
          </Row>
          {this.getActionsRow([
            [
              null,
              this.getHistoryButton(
                this.props.languageValues.reviewButton,
                this.props.languageValues.etapa5,
                this.props.projeto.historico &&
                  this.props.projeto.historico[this.stepIndex]
                  ? this.props.projeto.historico[this.stepIndex]
                  : [],
                this.stepIndex,
                this.props.openModal
              ),
            ],
            [
              null,
              this.getNextButton(
                !etapaIsUnlocked(
                  this.stepIndex,
                  this.props.projeto.avaliacoes
                ) || this.itemsAreValid(this.validationResults)
              ),
            ],
          ])}
        </form>
      </CustomCard>
    );
  }
}

const mapStateToProps = (state) => ({
  languageValues: state.languages.languageValues,
  projeto: state.projeto.projetoEditing,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      changeProjetoValue,
      saveProjeto,
      loadHistoricoAvaliacoes,
      openModal,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(Etapa5Card1));
